import { gql, MutationFunction } from '@apollo/client';

export const UpdateOrganizationGuestUsersSecurity = gql`
mutation UpdateOrganizationGuestUsersSecurity($code: String!, $input: GuestUsersSecurityUpdateInput!) {
	updateOrganizationGuestUsersSecurity(organizationCode: $code, input: $input)
}
`;

export type UpdateOrganizationGuestUsersSecurityMutation = MutationFunction<
  UpdateOrganizationGuestUsersSecurityData,
  UpdateOrganizationGuestUsersSecurityVariables
>;
